export default __webpack_public_path__ + "static/media/verlinde-banner-mobile.a59329f6.png";